<div class="post-word-container dialog-container">
    <div class="post-word">
        <div class="word">
            <h1>{{ post.game_word_1 }}</h1>
            <p>Co to może być?</p>
        </div>
        <div class="answer">
            <input [(ngModel)]="textValue" placeholder="ZAPROPONUJ ZNACZENIE" type="text"/>
            <button (click)="checkValue();" class="lite">Sprawdź</button>
        </div>
    </div>

    <div *ngIf="showDialog();" 
        class="answer-dialog"
        [ngClass]="(showDialogNotOk)? 'answer-incorrect' : ''">
        <div class="close-button"
            (click)="closeDialog();">
            x
        </div>
        <div *ngIf="showDialogOk" class="correct">
            <h1>Juuhuuu!</h1>
            <p>Właściwe znaczenie!</p>
        </div>
        <div *ngIf="showDialogNotOk" class="correct">
            <h1>Poznaj znaczenie!</h1>
            <p class="answer">
                {{ post.game_word_1 }} - {{ post.game_word_2 }}
            </p>
        </div>
        <button *ngIf="post.next" 
            class="lite"
            [routerLink]="['/task', post.next]">
            Poznaj kolejne słówko!
        </button>
        <button *ngIf="!post.next" 
            class="lite"
            routerLink="/categories">
            Powrót do kategorii
        </button>
    </div>
</div>    
